export const DEFAULT_PRIMARY_COLOR = '#23537E';
export const LOGO_BASE_URL = process.env.REACT_APP_LOGO_BASE_URL ?? '';
